import React from 'react'

const AnswerSection = ({ storedValues }) => {
    const copyText = (text) => {
        navigator.clipboard.writeText(text);
    };

    return (
        <>
            <hr className="hr-line" />
            <div className="answer-container">
                {storedValues.map((value, index) => {
                    return (
                        <div className="answer-section" key={index}>
                            <p className="question">{value.question}</p>
                            <p className="answer">{value.answer}</p>
                            <button className="copy-icon" onClick={() => copyText(value.answer)}>
                                Копировать
                                <br />
                                ответ
                            </button>
                        </div>
                    );
                })}
            </div>
        </>
    )
}

export default AnswerSection